import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const FormatBoldNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M16.25 11.5C17.25 10.5 17.75 9.25 17.75 8.32143C17.75 5.75 15.75 3.75 13.25 3.75H7.81395C6.81213 3.75 6 4.51751 6 5.46429V18.5357C6 19.4825 6.81213 20.25 7.81395 20.25H14.25C16.75 20.25 18.25 17.75 18.25 15.75C18.25 13.75 17.25 12.5 16.25 11.5ZM9 6.25H12.75C13.7537 6.25 14.7635 6.75 14.75 8.32143C14.7377 9.74995 13.7537 10.5 12.75 10.5H9V6.25ZM13.25 17.75H9V13.5H13.25C14.6919 13.5 15.25 14.75 15.25 15.75C15.25 16.75 14.6919 17.75 13.25 17.75Z'
            fill='currentColor'
        />
    </svg>
));
